/**
 * The StaySuite mark, inline so it inherits currentColor and needs no network request
 * on first paint — the login screen is the first thing anyone sees of the brand.
 *
 * `tile` draws the teal rounded square (app icon, login, guest pages). Without it the
 * house is drawn in the current text colour, for use inside a coloured button or bar.
 */
export function Logo({
  size = 40, tile = true, className,
}: { size?: number; tile?: boolean; className?: string }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 512 512"
      className={className} role="img" aria-label="StaySuite"
    >
      {tile && (
        <>
          <defs>
            <linearGradient id="ss-logo-tile" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stopColor="#12867c" />
              <stop offset="1" stopColor="#0d5f57" />
            </linearGradient>
          </defs>
          <rect width="512" height="512" rx="112" fill="url(#ss-logo-tile)" />
        </>
      )}
      <path
        fill={tile ? '#ffffff' : 'currentColor'}
        fillRule="evenodd"
        d="M242 104a22 22 0 0 1 28 0l142 118a22 22 0 0 1 8 17v145a24 24 0 0 1-24 24H124a24 24 0 0 1-24-24V239a22 22 0 0 1 8-17ZM178 300a16 16 0 0 0-16 16v56h40v-30h108v30h40v-56a16 16 0 0 0-16-16Z"
      />
    </svg>
  )
}

/** Mark plus wordmark. `Stay` in the text colour, `Suite` in the accent. */
export function Wordmark({ size = 40 }: { size?: number }) {
  return (
    <span className="inline-flex items-center gap-3">
      <Logo size={size} />
      <span
        className="font-semibold tracking-tight"
        style={{ fontSize: size * 0.62 }}
      >
        Stay<span className="text-accent">Suite</span>
      </span>
    </span>
  )
}
